import React, { useState } from 'react';
import { DefaultButton } from '@fluentui/react';

interface IProps {
    /** Arma y descarga el archivo. Puede pedir datos antes, por eso es asíncrona. */
    onExport: () => Promise<void> | void;
    disabled?: boolean;
    label?: string;
}

/**
 * Botón "Descargar Excel" de las tarjetas de estadísticas.
 *
 * Mientras prepara el archivo se deshabilita y lo dice —algunas exportaciones
 * piden el detalle completo antes de descargar—, y si algo falla lo avisa al lado
 * en vez de no hacer nada.
 */
export const ExcelExportButton: React.FC<IProps> = ({ onExport, disabled, label = 'Descargar Excel' }) => {
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const [failed, setFailed] = useState<boolean>(false);

    const handleClick = async () => {
        setIsBusy(true);
        setFailed(false);
        try {
            await onExport();
        } catch {
            setFailed(true);
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <div className="cs-export">
            <DefaultButton
                className="cs-export__button"
                iconProps={{ iconName: 'ExcelDocument' }}
                text={isBusy ? 'Preparando…' : label}
                onClick={handleClick}
                disabled={disabled || isBusy}
            />
            {failed && (
                <span className="cs-export__error" role="alert">
                    No se pudo generar el Excel.
                </span>
            )}
        </div>
    );
};

export default ExcelExportButton;
